import { ReactNode, useEffect } from 'react'
import { useRouter } from 'next/router'
import { useAuth } from '@root/hooks'
import { MetaTagsProps } from '@root/types'
import PlaceholderLoader from '@root/components/Loader/PlaceholderLoader'
import { PROTECTED_PAGES_PATHS, UNPROTECTED_PAGES_PATHS } from '@root/constants'
import { segmentApi } from '@root/api'
import { useAuthTemporalStore } from '@root/store'
import { MetaTags } from './MetaTags'

interface GuestLayoutProps extends MetaTagsProps {
  children: ReactNode
}

const GuestLayout = (props: GuestLayoutProps): JSX.Element => {
  const { children, title } = props
  const { status } = useAuth()
  const router = useRouter()
  const { pastStates } = useAuthTemporalStore((state) => state)
  // check if previous status is has `unauthorized` status
  const isPreviousStatusUnauthorized = pastStates.some(
    (pastState) => pastState.status === 'unauthorized'
  )

  const shouldDisplayLoader: boolean =
    status === 'loading' ||
    // if current status is `authorized` and previous status has `unauthorized` state,
    // mark `isPreviousStatusUnauthorized` as the opposite to prevent displaying loader
    (status === 'authorized' && !isPreviousStatusUnauthorized)

  // exception PATH doesn't requires to be logged in and not redirect to dashboard
  const exceptionPath = [
    UNPROTECTED_PAGES_PATHS.mfaOptions,
    UNPROTECTED_PAGES_PATHS.mfaCode,
  ]

  useEffect(() => {
    segmentApi.page()
  }, [])

  // redirect to dashboard if user is logged in
  useEffect(() => {
    if (status === 'authorized' && !exceptionPath.includes(router.pathname)) {
      router.push(PROTECTED_PAGES_PATHS.offers)
    }
  }, [status])

  return (
    <>
      <MetaTags title={title} />
      {shouldDisplayLoader ? <PlaceholderLoader /> : children}
    </>
  )
}

export { GuestLayout }
